module.exports = __webpack_public_path__ + "img/cement-modeling-id.d18fee4d.png";